// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserSelectModal_userModalOverlay__3B\\+YQ {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.UserSelectModal_userModal__IaoBj {
  background: #ffffff;
  border-radius: 12px;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 48px -10px rgba(0, 0, 0, 0.35);
  overflow: hidden;
  font-family: system-ui,-apple-system,BlinkMacSystemFont,sans-serif;
}

.UserSelectModal_userModalHeader__\\+EJqC {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  gap: 0.5rem;
}

.UserSelectModal_userModalHeader__\\+EJqC h3 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
}

.UserSelectModal_closeBtn__1boxA {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  padding: 0.25rem;
  color: #374151;
  transition: color .2s ease;
}

.UserSelectModal_closeBtn__1boxA:hover,
.UserSelectModal_closeBtn__1boxA:focus {
  color: #111827;
  outline: none;
}

.UserSelectModal_userModalBody__93\\+yq {
  padding: 0.75rem 1rem;
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.UserSelectModal_userSearchInput__otkd5 {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.95rem;
  outline: none;
  box-sizing: border-box;
  transition: border-color .2s ease, box-shadow .2s ease;
}

.UserSelectModal_userSearchInput__otkd5:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25);
}

.UserSelectModal_userSelectList__Hm2PY {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 4px;
}

.UserSelectModal_userItemManual__E31VH {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.65rem 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  background: #f9fafb;
  transition: background .15s ease, transform .1s ease;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.UserSelectModal_userItemManual__E31VH:hover {
  background: #f3f4f6;
}

.UserSelectModal_userItemManual__E31VH:active {
  transform: scale(.99);
}

.UserSelectModal_hasAccessManual__H0ZXo {
  opacity: 0.65;
  background: #eef6f8;
  cursor: default;
  position: relative;
}

.UserSelectModal_smallText__-3lRY {
  font-size: 0.75rem;
  color: #6b7280;
  margin-left: 4px;
}

.UserSelectModal_tag__Gqb\\+M {
  background: #10b981;
  color: white;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.6rem;
  font-weight: 600;
  white-space: nowrap;
  margin-left: 8px;
}

.UserSelectModal_userModalFooter__vQFTZ {
  padding: 0.75rem 1rem;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.UserSelectModal_btnClose__w-d9K {
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  padding: 0.55rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background .2s ease, border-color .2s ease;
}

.UserSelectModal_btnClose__w-d9K:hover {
  background: #e2e6ea;
}

.UserSelectModal_errorText__Jn5rL {
  color: #b91c1c;
  font-size: 0.85rem;
  margin: 0;
}

/* Scrollbar for overflow areas (optional enhancement) */
.UserSelectModal_userModalBody__93\\+yq::-webkit-scrollbar {
  width: 10px;
}
.UserSelectModal_userModalBody__93\\+yq::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 6px;
}
.UserSelectModal_userModalBody__93\\+yq::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 6px;
}
.UserSelectModal_userModalBody__93\\+yq::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Responsive tweaks */
@media (max-width: 600px) {
  .UserSelectModal_userModal__IaoBj {
    max-width: 100%;
    border-radius: 10px;
  }
  .UserSelectModal_userModalHeader__\\+EJqC h3 {
    font-size: 1rem;
  }
  .UserSelectModal_userItemManual__E31VH {
    flex-direction: column;
    align-items: flex-start;
  }
  .UserSelectModal_tag__Gqb\\+M {
    margin-top: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/Dispatcher/GiveAccess/components/UserSelectModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iDAAiD;EACjD,gBAAgB;EAChB,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oDAAoD;EACpD,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA,wDAAwD;AACxD;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".userModalOverlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.45);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 1rem;\r\n  z-index: 1000;\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.userModal {\r\n  background: #ffffff;\r\n  border-radius: 12px;\r\n  width: 100%;\r\n  max-width: 480px;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 20px 48px -10px rgba(0, 0, 0, 0.35);\r\n  overflow: hidden;\r\n  font-family: system-ui,-apple-system,BlinkMacSystemFont,sans-serif;\r\n}\r\n\r\n.userModalHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0.75rem 1rem;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.userModalHeader h3 {\r\n  margin: 0;\r\n  font-size: 1.125rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.closeBtn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.5rem;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  padding: 0.25rem;\r\n  color: #374151;\r\n  transition: color .2s ease;\r\n}\r\n\r\n.closeBtn:hover,\r\n.closeBtn:focus {\r\n  color: #111827;\r\n  outline: none;\r\n}\r\n\r\n.userModalBody {\r\n  padding: 0.75rem 1rem;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.userSearchInput {\r\n  width: 100%;\r\n  padding: 0.5rem 0.75rem;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 8px;\r\n  font-size: 0.95rem;\r\n  outline: none;\r\n  box-sizing: border-box;\r\n  transition: border-color .2s ease, box-shadow .2s ease;\r\n}\r\n\r\n.userSearchInput:focus {\r\n  border-color: #6366f1;\r\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25);\r\n}\r\n\r\n.userSelectList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  margin-top: 4px;\r\n}\r\n\r\n.userItemManual {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0.65rem 0.75rem;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  background: #f9fafb;\r\n  transition: background .15s ease, transform .1s ease;\r\n  gap: 0.5rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.userItemManual:hover {\r\n  background: #f3f4f6;\r\n}\r\n\r\n.userItemManual:active {\r\n  transform: scale(.99);\r\n}\r\n\r\n.hasAccessManual {\r\n  opacity: 0.65;\r\n  background: #eef6f8;\r\n  cursor: default;\r\n  position: relative;\r\n}\r\n\r\n.smallText {\r\n  font-size: 0.75rem;\r\n  color: #6b7280;\r\n  margin-left: 4px;\r\n}\r\n\r\n.tag {\r\n  background: #10b981;\r\n  color: white;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  font-size: 0.6rem;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  margin-left: 8px;\r\n}\r\n\r\n.userModalFooter {\r\n  padding: 0.75rem 1rem;\r\n  border-top: 1px solid #e5e7eb;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.btnClose {\r\n  background: #f3f4f6;\r\n  border: 1px solid #d1d5db;\r\n  padding: 0.55rem 1rem;\r\n  border-radius: 8px;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: background .2s ease, border-color .2s ease;\r\n}\r\n\r\n.btnClose:hover {\r\n  background: #e2e6ea;\r\n}\r\n\r\n.errorText {\r\n  color: #b91c1c;\r\n  font-size: 0.85rem;\r\n  margin: 0;\r\n}\r\n\r\n/* Scrollbar for overflow areas (optional enhancement) */\r\n.userModalBody::-webkit-scrollbar {\r\n  width: 10px;\r\n}\r\n.userModalBody::-webkit-scrollbar-track {\r\n  background: #f1f5f9;\r\n  border-radius: 6px;\r\n}\r\n.userModalBody::-webkit-scrollbar-thumb {\r\n  background: #cbd5e1;\r\n  border-radius: 6px;\r\n}\r\n.userModalBody::-webkit-scrollbar-thumb:hover {\r\n  background: #94a3b8;\r\n}\r\n\r\n/* Responsive tweaks */\r\n@media (max-width: 600px) {\r\n  .userModal {\r\n    max-width: 100%;\r\n    border-radius: 10px;\r\n  }\r\n  .userModalHeader h3 {\r\n    font-size: 1rem;\r\n  }\r\n  .userItemManual {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  .tag {\r\n    margin-top: 4px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userModalOverlay": `UserSelectModal_userModalOverlay__3B+YQ`,
	"userModal": `UserSelectModal_userModal__IaoBj`,
	"userModalHeader": `UserSelectModal_userModalHeader__+EJqC`,
	"closeBtn": `UserSelectModal_closeBtn__1boxA`,
	"userModalBody": `UserSelectModal_userModalBody__93+yq`,
	"userSearchInput": `UserSelectModal_userSearchInput__otkd5`,
	"userSelectList": `UserSelectModal_userSelectList__Hm2PY`,
	"userItemManual": `UserSelectModal_userItemManual__E31VH`,
	"hasAccessManual": `UserSelectModal_hasAccessManual__H0ZXo`,
	"smallText": `UserSelectModal_smallText__-3lRY`,
	"tag": `UserSelectModal_tag__Gqb+M`,
	"userModalFooter": `UserSelectModal_userModalFooter__vQFTZ`,
	"btnClose": `UserSelectModal_btnClose__w-d9K`,
	"errorText": `UserSelectModal_errorText__Jn5rL`
};
export default ___CSS_LOADER_EXPORT___;
